import React, { useState } from 'react';
import { tiposViaje } from '../data/contenido';
import { contacto } from '../data/viajes';
import { LIMITE_VIAJEROS, ajustarViajeros, armarMensajeViaje, wa } from '../services/whatsapp';
import './Contacto.css';

function Contador({ label, valor, limite, onChange }) {
  return (
    <div className="contacto__cnt">
      <span>{label}</span>
      <span className="contacto__cnt-c">
        <button onClick={() => onChange(ajustarViajeros(valor - 1, limite))} aria-label={`Menos ${label.toLowerCase()}`}><i className="fa-solid fa-minus" /></button>
        <b>{valor}</b>
        <button onClick={() => onChange(ajustarViajeros(valor + 1, limite))} aria-label={`Más ${label.toLowerCase()}`}><i className="fa-solid fa-plus" /></button>
      </span>
    </div>
  );
}

export default function Contacto() {
  const [tipo, setTipo] = useState(tiposViaje[0]);
  const [adultos, setAdultos] = useState(LIMITE_VIAJEROS.adultos.inicial);
  const [ninos, setNinos] = useState(LIMITE_VIAJEROS.ninos.inicial);
  const [fecha, setFecha] = useState('');
  const [nombre, setNombre] = useState('');

  const mensaje = armarMensajeViaje({ tipo, adultos, ninos, fecha, nombre });
  // En pantallas angostas el correo se parte después de la @ (no a mitad del dominio)
  const [usuarioCorreo, dominioCorreo] = contacto.email.split('@');

  return (
    <section id="contacto" className="contacto sec on-dark">
      <div className="wrap contacto__grid">
        <div className="contacto__info" data-reveal>
          <h2 className="h2 contacto__h2">¿A dónde <em>te llevo?</em></h2>
          <p className="lead">Cuéntame un poco de tu viaje y te respondo personalmente por WhatsApp. Sin compromiso.</p>
          <p className="eyebrow contacto__eyebrow">Contacto</p>
          <div className="contacto__datos">
            <a href={`tel:+${contacto.wa}`}><i className="fa-solid fa-phone" /><span>{contacto.telefono}</span></a>
            <a href={`mailto:${contacto.email}`}><i className="fa-solid fa-envelope" /><span>{usuarioCorreo}@<wbr />{dominioCorreo}</span></a>
            <div><i className="fa-solid fa-location-dot" /><span>{contacto.ubicacion}</span></div>
          </div>
          <div className="contacto__redes">
            <a href={contacto.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa-brands fa-instagram" /></a>
            <a href={contacto.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><i className="fa-brands fa-tiktok" /></a>
            <a href={contacto.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa-brands fa-facebook-f" /></a>
            <a href={contacto.cita} target="_blank" rel="noopener noreferrer" className="contacto__cita"><i className="fa-regular fa-calendar" />Agendar una videollamada</a>
          </div>
        </div>

        <div className="contacto__card" data-reveal>
          <p className="contacto__t">Arma tu mensaje</p>
          <p className="contacto__s">Elige lo que buscas y te lo mando listo a mi WhatsApp.</p>
          <p className="contacto__lbl">¿Qué viaje sueñas?</p>
          <div className="contacto__chips">
            {tiposViaje.map((t) => <button key={t} className={tipo === t ? 'is-on' : ''} onClick={() => setTipo(t)} aria-pressed={tipo === t}>{t}</button>)}
          </div>
          <div className="contacto__row">
            <Contador label="Adultos" valor={adultos} limite={LIMITE_VIAJEROS.adultos} onChange={setAdultos} />
            <Contador label="Niños" valor={ninos} limite={LIMITE_VIAJEROS.ninos} onChange={setNinos} />
          </div>
          <div className="contacto__row">
            <input type="text" value={fecha} onChange={(e) => setFecha(e.target.value)} placeholder="¿Cuándo? Ej. diciembre 2026" aria-label="Fecha aproximada" />
            <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Tu nombre" aria-label="Tu nombre" />
          </div>
          <p className="contacto__lbl">Así me llegará</p>
          <div className="contacto__preview"><div>{mensaje}</div></div>
          <a className="btn-wa contacto__send" href={wa(mensaje)} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" />Enviar por WhatsApp</a>
          <p className="contacto__mail">¿Prefieres correo? <a href={`mailto:${contacto.email}`}>{contacto.email}</a></p>
        </div>
      </div>
    </section>
  );
}
